export default "__VITE_ASSET__CZixepTf__"